import Component from '@glimmer/component';
import AditoolsMenuContext from './aditools-menu-context.ts';
import AditoolsMenuLinks from './aditools-menu-links.ts';

interface AditoolsNarrowMenubarSignature {
  Element: HTMLMenuElement;
  Blocks: {
    default: [
      {
        'menu-context': typeof AditoolsMenuContext;
        'menu-links': typeof AditoolsMenuLinks;
      },
    ];
  };
}

export default class AditoolsNarrowMenubar extends Component<AditoolsNarrowMenubarSignature> {
  menuContextClass = AditoolsMenuContext;
  menuLinksClass = AditoolsMenuLinks;
}
